/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_First_NameInputs */

const cs_form_first_name = /** @type {(inputs: Form_First_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jméno`)
};

const en_form_first_name = /** @type {(inputs: Form_First_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First name`)
};

/**
* | output |
* | --- |
* | "First name" |
*
* @param {Form_First_NameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_first_name = /** @type {((inputs?: Form_First_NameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_First_NameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_first_name(inputs)
	return cs_form_first_name(inputs)
});